export default __webpack_public_path__ + "static/8-b90e98e050b016b870ffdc0e2807adf9.jpg";